export const isInputElement = (element: any): element is HTMLInputElement =>
  element?.tagName === 'INPUT';
